import { useQuery } from '@tanstack/react-query';
import jwt_decode, { JwtPayload } from 'jwt-decode';

import { customAxios } from 'lib/axios';
import { User } from 'types';
import storage from 'utils/storage';

type Payload = JwtPayload & {
  _id: string;
};

const getUser = async (
  signal: AbortSignal | undefined
): Promise<User | null> => {
  const token = storage.getToken();
  if (token) {
    const decoded = jwt_decode<Payload>(token);
    const userId = decoded._id;
    const { data } = await customAxios.get<User>(`/users/${userId}`, {
      signal,
    });
    return data;
  }
  return null;
};

// 5 min – avoid 429 from frequent refetches
const STALE_TIME_MS = 5 * 60 * 1000;

export const useGetUser = () =>
  useQuery({
    queryKey: ['auth-user'],
    queryFn: ({ signal }) => getUser(signal),
    retry: false,
    staleTime: STALE_TIME_MS,
    refetchOnWindowFocus: false,
  });
